module.exports = __webpack_public_path__ + "static/img/12.c1a5485.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/12.png
// module id = Qch7
// module chunks = 1